<template>
  <div>
    <vxe-grid
      ref="predictTable"
      auto-resize
      highlight-hover-row
      resizable
      border
      size="mini"
      cell-class-name="align-top"
      :loading="loading"
      :data="tableData"
      :columns="tableColumns"
      :edit-config="{ enabled: !disabled, trigger: 'click', mode: 'row' }"
      @edit-closed="editClosed"
    >
      <template v-slot:opt="{ row }">
        <el-tooltip
          class="item"
          effect="dark"
          content="清空数据"
          placement="top"
        >
          <i
            class="el-icon-circle-close tool-btn mr-2"
            @click.stop="onClearRow(row)"
          ></i>
        </el-tooltip>
        <el-tooltip class="item" effect="dark" content="删除行" placement="top">
          <i
            class="el-icon-delete tool-btn mr-2"
            @click.stop="onDelRow(row)"
          ></i>
        </el-tooltip>
      </template>
    </vxe-grid>
  </div>
</template>
<script>
import { format } from '@/libs/util.number.js'
import tableColumns from './table-columns'

import EditLoading from '@/mixins/edit-loading'
export default {
  mixins: [EditLoading],
  props: {
    tablePage: { type: Object, default: () => {} },
    disabled: { type: Boolean, default: false },
    amzReplenishmentCode: { typ: String, default: '' },
    amazonStoreRegion: { typ: String, default: '' },
    highlightCurrentRow: { typ: Boolean, default: false },
  },
  data() {
    return {
      format: (number) => format(number),
      tableData: [],
      loading: false,
    }
  },
  computed: {
    tableColumns() {
      return tableColumns(this)
    },
  },
  mounted() {
    this.getData()
  },
  methods: {
    async onClearRow({ amzReplenishmentPromotionCode }) {
      if (!amzReplenishmentPromotionCode) {
        return
      }
      const confirm = await this.$confirm(
        this.$l('INDEX.tips_clear_data') || '是否要清空数据？',
        this.$l('INDEX.label_completeDesc') || '确认信息',
        {
          confirmButtonText:
            this.$l('INDEX.product_dialog_btn_confirm') || '确定',
          cancelButtonText: this.$l('INDEX.btn_cancel') || '取消',
          type: 'warning',
        }
      )
        .then(() => true)
        .catch(() => false)
      if (!confirm) return
      if (this.loadingOpen()) return
      const res = await this.$api.ecomAmzReplenishmentPromotionClearApi({
        amzReplenishmentPromotionCode,
      })
      this.loadingClose()
      if (!res) return
      this.$message({
        showClose: true,
        message: this.$l('INDEX.tips_clear_success') || '清空成功！',
        type: 'success',
      })
      await this.getData()
    },
    async getData() {
      if (!this.amzReplenishmentCode || !this.amazonStoreRegion) return

      this.loading = true
      const res = await this.$api
        .ecomAmzReplenishmentPromotionListApi({
          amzReplenishmentCode: this.amzReplenishmentCode,
          amazonStoreRegion: this.amazonStoreRegion,
        })
        .catch(() => null)
      this.loading = false
      if (!res) return
      this.tableData = res.body.data || []
    },
    async onDelRow({ amzReplenishmentPromotionCode }) {
      const confirm = await this.$confirm(
        this.$l('INDEX.tips_delete') || '是否要删除该记录？',
        this.$l('INDEX.label_completeDesc') || '确认信息',
        {
          confirmButtonText:
            this.$l('INDEX.product_dialog_btn_confirm') || '确定',
          cancelButtonText: this.$l('INDEX.btn_cancel') || '取消',
          type: 'warning',
        }
      )
        .then(() => true)
        .catch(() => false)
      if (!confirm) return
      if (this.loadingOpen()) return
      const res = await this.$api
        .ecomAmzReplenishmentPromotionDelRowApi({
          amzReplenishmentCode: this.amzReplenishmentCode,
          amazonStoreRegion: this.amazonStoreRegion,
          amzReplenishmentPromotionCode,
        })
        .catch(() => null)
      this.loadingClose()
      if (!res) return
      this.$message({
        showClose: true,
        message: this.$l('INDEX.tips_delete_ok') || '删除成功！',
        type: 'success',
      })
      await this.getData()
    },
    async editClosed({ row }) {
      if (this.loadingOpen()) return
      const res = await this.$api
        .ecomAmzReplenishmentPromotionSaveApi({
          ...row,
          amzReplenishmentCode: this.amzReplenishmentCode,
          amazonStoreRegion: this.amazonStoreRegion,
        })
        .catch(() => null)
      this.loadingClose()
      if (!res) return
      this.$message.success(this.$l('INDEX.tips_save_ok') || '保存成功')
      await this.getData()
    },
  },
}
</script>
<style lang="scss" scoped>
::v-deep {
  .vxe-cell {
    > div {
      margin-top: 7px;
    }
  }
  .vxe-table--render-default .vxe-body--row:first-child .vxe-cell--valid {
    top: initial;
    padding-top: 4px;
  }
  .col-opt {
    padding-top: 0 !important;
  }
  .col--seq {
    padding-top: 11px !important;
  }
}
</style>
